<ng-container *ngIf="!isLoading.availableStore && availableStoreIds.length; else paymentApprovalAccessForbidden">
  <div class="m-subheader">
    <div class="d-flex align-items-center">
      <div class="mr-auto">
        <h3 class="m-subheader__title">
          {{ 'paymentApproval.title' | transloco }}
        </h3>
      </div>
      <div>
        <button (click)="paidModal()"
                [disabled]="isLoading.paid"
                [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.paid}"
                type="button"
                class="btn btn-outline-warning m-btn m-btn--icon m--margin-right-10"
                [title]="'payment-approval-list.paid' | transloco">
        <span>
          <i class="la la-money-bill"></i>
          <span>{{ 'payment-approval-list.btn.paid' | transloco }}</span>
        </span>
        </button>
      </div>
      <div>
        <app-payment-approval-edit [id]="paymentApprovalId"
                                   (paymentApprovalSave)="onPaymentApprovalSaved($event)"></app-payment-approval-edit>
      </div>
    </div>
  </div>


  <div class="m-content">
    <div class="row">
      <div class="col-sm-12">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="hx-filters">
              <div class="filter">
                <small>{{ 'payment-approval-list.shop' | transloco }}</small>
                <hx-store-select [(ngModel)]="params.storeId" [filterFn]="onStoreFilterFn"
                                 (selectChange)="applyFilters()"></hx-store-select>
              </div>

              <div class="filter">
                <small>{{ 'payment-approval-list.data' | transloco }}</small>
                <hx-date-range-select [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
              </div>

              <div class="filter">
                <small>{{ 'payment-approval-list.search' | transloco }}</small>
                <form class="m-form" (ngSubmit)="applyFilters()">
                  <div class="m-form__section m-form__section--first">
                    <div class="form-group m-form__group m--margin-top-0">
                      <div class="input-group">
                        <input type="text" required [(ngModel)]="params.query" name="query" class="form-control m-input"
                               [placeholder]="'payment-approval-list.searchNum' | transloco">
                        <span class="input-group-btn">
                        <button class="btn btn-outline-primary" type="submit">
                          {{ 'payment-approval-list.btn.search' | transloco }}
                        </button>
                      </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="filter" *ngIf="params.storeId">
                <small>{{ 'payment-approval-list.supplier' | transloco }}</small>
                <app-suppliers-search [(ngModel)]="params.supplierId" [storeId]="params.storeId"
                                      (selectChange)="applyFilters()"></app-suppliers-search>
              </div>

              <div class="filter">
                <small>&nbsp;</small>
                <hx-checkbox [(ngModel)]="params.paid" label="filter.paid" (valueChange)="applyFilters()"></hx-checkbox>
              </div>

              <div class="row align-content-md-end m--margin-top-20">
                <div class="col-md-5">
                  <button type="button" (click)="resetFilter()"
                          class="btn btn-outline-primary m-btn m-btn--custom m-btn--icon m--margin-bottom-30">
                    {{ 'reset.list' | transloco }}
                  </button>
                </div>
              </div>
            </div>

            <!--          <app-store-products-new [id]="storeProductId" (update)="updater($event)"></app-store-products-new>-->

            <div
              class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-bottom-30"
              *ngIf="list.length && !isLoading.list">
              <table class="m-datatable__table">
                <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">
                    <label class="m-checkbox m--margin-left-3" (change)="checkAll()">
                      <input type="checkbox" [(ngModel)]="isAll">
                      <span></span>
                    </label>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'payment-approval-list.number' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'payment-approval-list.shop' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'payment-approval-list.supplier' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'payment-approval-list.status' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'payment-approval-list.data' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'payment-approval-list.dataPaid' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'payment-approval-list.knp' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'payment-approval-list.sum' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'payment-approval-list.events' | transloco }}</span>
                  </th>
                </tr>
                </thead>
                <tbody class="m-datatable__body">
                <tr *ngFor="let even = even; let i = index; let pa of list"
                    class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even}">
                  <td class="m-datatable__cell">
                    <label class="m-checkbox" (change)="togglePaymentApproval(pa)">
                      <input [disabled]="pa.paymentDate || pa.status !== createdStatus" type="checkbox"
                             [name]="'checkbox_' + pa.id"
                             [checked]="pa.selected">
                      <span></span>
                    </label>
                  </td>
                  <td class="m-datatable__cell">
                    <a (click)="view(pa)">№{{ pa.number }}</a>
                  </td>
                  <td class="m-datatable__cell">
                    {{ pa.store.title | uiLabel }}
                  </td>
                  <td class="m-datatable__cell">
                    {{ pa.supplier.name }}
                  </td>
                  <td class="m-datatable__cell">
            <span class="m-badge m-badge--{{ statusOptions.get(pa.status)?.badge }} m-badge--wide m-badge--rounded"
                  [ngbTooltip]="pa.cancelReason">
              {{ 'paymentApproval.status.' + pa.status | transloco }}
            </span>
                  </td>
                  <td class="m-datatable__cell">
                    <div>{{ pa.date | date:'dd.MM.yyyy HH:mm' }}</div>
                  </td>
                  <td class="m-datatable__cell">
                    <div>{{ pa.paymentDate | date:'dd.MM.yyyy HH:mm' }}</div>
                  </td>
                  <td class="m-datatable__cell text-right">
                    {{ pa.paymentDestinationCode }}
                  </td>
                  <td class="m-datatable__cell text-right">
                    {{ pa.total }}
                  </td>
                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 102px;">
                    <a *ngIf="pa.status === createdStatus" (click)="updateItem(pa)"
                       class="btn btn-outline-primary btn-sm m-btn m-btn--icon m--margin-left-5" [title]="'payment-approval-list.change' | transloco">
                      <i class="la la-edit"></i>
                    </a>
                    <a *ngIf="pa.status === createdStatus" (click)="paidSingleModal(pa)"
                       class="btn btn-outline-warning m-btn btn-sm m-btn--icon m--margin-left-5"
                       [ngbTooltip]="'payment-approval-list.paidOrder' | transloco">
                      <i class="la la-money-bill"></i>
                    </a>
                    <a *ngIf="pa.status === createdStatus" (click)="cancelModal(pa)"
                       class="btn btn-outline-danger m-btn btn-sm m-btn--icon m--margin-left-5"
                       [ngbTooltip]="'payment-approval-list.paidOrder' | transloco">
                      <i class="la la-times"></i>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

            <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
              <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                              [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)"
                              class="d-flex justify-content-center mt-4">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #paymentApprovalAccessForbidden>
  <h3 style="position: absolute;top: 50%;left: 40%;">{{ 'payment-approval-list.text-1' | transloco }}</h3>
</ng-template>

<ng-template #cancelTemplateRef let-modal>
  <div class="modal-header">
    <p>{{ 'paymentApproval.question.cancel' | transloco :{number: selectedPaymentApproval.number} }}?</p>
  </div>

  <div class="modal-body">
    <textarea type="text" [(ngModel)]="reason"
              class="form-control m-input" [placeholder]="'paymentApproval.question.cancel' | transloco" [title]="'paymentApproval.question.cancel' | transloco">
    </textarea>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-success m--margin-right-10" (click)="cancel(modal)">{{ 'payment-approval-list.btn.yes' | transloco }}</button>

    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">{{ 'payment-approval-list.btn.no' | transloco }}</button>
  </div>
</ng-template>


<ng-template #paidTemplateRef let-modal>
  <div class="modal-header">
    <p>{{ 'paymentApproval.question.paid' | transloco }}?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-success m--margin-right-10" (click)="paidConfirm(modal)">{{ 'payment-approval-list.btn.yes' | transloco }}</button>

    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">{{ 'payment-approval-list.btn.no' | transloco }}</button>
  </div>
</ng-template>
